import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageBanner({ title, crumb, subtitle }) {
  return (
    <section className="relative bg-homi-black overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 15% 30%, #c8912f 0, transparent 40%), radial-gradient(circle at 85% 70%, #c8912f 0, transparent 42%)" }} />
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20 relative text-center">
        <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-white mb-4">{title}</h1>
        {subtitle && <p className="text-white/70 max-w-2xl mx-auto mb-5">{subtitle}</p>}
        <div className="flex items-center justify-center gap-2 text-sm font-heading font-semibold">
          <Link to="/homi" className="text-white/70 hover:text-homi-gold transition-colors">Home</Link>
          <ChevronRight className="w-4 h-4 text-homi-gold" />
          <span className="text-homi-gold">{crumb}</span>
        </div>
      </div>
    </section>
  );
}
